export const AdjustTypeCssClasses = [
  '',
  'success',
  'dark',
  'info',
  'danger',
  'primary',
];
export const AdjustTypeTitles = [
  '',
  'Хэвийн',
  'Задарсан',
  'Хуваагдсан',
  'Бүтээгдэхүүн солигдсон',
  'Нэгтгэгдсэн',
];

export const adjustTypeList = [
  { code: '', name: '' },
  { code: 'NONE', name: 'Хэвийн' },
  { code: 'EXTRACTED', name: 'Задарсан' },
  { code: 'DIVIDED', name: 'Хуваагдсан' },
  { code: 'CHANGED', name: 'Бүтээгдэхүүн солигдсон' },
  { code: 'BUNDLED', name: 'Нэгтгэгдсэн' },
];

export const defaultSorted = [{ dataField: 'a.created_at', order: 'desc' }];
export const sizePerPageList = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
  { text: '100', value: 100 },
];
export const initialFilter = {
  filter: {
    from: '', //Date.now(),
    to: '', //"",
    searchText: '',
    adjustType: '',
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'a.created_at',
  pageNumber: 1,
  pageSize: 10,
};

export const initialStock = {
  id: undefined,
  adjustType: 'NONE',
  ison: '',
  productCode: '',
  qty: 0,
  cost: '',
  rest: 0,
  expireDate: undefined,
  note: '',
  orderDate: '',
  orderCode: '',
  trackingId: '',
  parentStockId: '',
  name: '',
  brandName: '',
  categoryName: '',
  productPrice: '',
  productCost: '',
  productCount: 0,
  productWeight: '',
  productSubProduct: 0,
  boxId: '',
};
